/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Driverremittance_Void_Title1Inputs */

const vi_driverremittance_void_title1 = /** @type {(inputs: Driverremittance_Void_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huỷ phiếu nộp quỹ`)
};

/**

* @param {Driverremittance_Void_Title1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const driverremittance_void_title1 = /** @type {((inputs?: Driverremittance_Void_Title1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Driverremittance_Void_Title1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_driverremittance_void_title1(inputs)
});
export { driverremittance_void_title1 as "driverRemittance_void_title" }